import React from 'react';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Link } from '@sravni/react-design-system/lib/Typography';
import { Dzen, Odnoklassniki, Viber, VK, Telegram, Instagram, Facebook } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils/lib/hooks';
import modules_b21bc4dc from '../styles/Socials.module.less.js';
import { SocialLinkType } from '../types/Socials.types.js';

const createIconBySocialItem = (item) => {
    const { text } = item;
    switch (text) {
        case SocialLinkType.FACEBOOK:
            return React.createElement(Facebook, null);
        case SocialLinkType.INSTAGRAM:
            return React.createElement(Instagram, null);
        case SocialLinkType.TELEGRAM:
            return React.createElement(Telegram, null);
        case SocialLinkType.VK:
            return React.createElement(VK, null);
        case SocialLinkType.VIBER:
            return React.createElement(Viber, null);
        case SocialLinkType.OK:
            return React.createElement(Odnoklassniki, null);
        case SocialLinkType.DZEN:
            return React.createElement(Dzen, null);
        default:
            return null;
    }
};
const filterByAvailableIcons = (socialLinks) => socialLinks.filter((item) => Object.values(SocialLinkType).includes(item.text));
const SocialList = (props) => {
    const { socialLinks } = props;
    const clearSocialLinks = filterByAvailableIcons(socialLinks);
    return (React.createElement(React.Fragment, null, clearSocialLinks.map((social) => {
        const IconSocial = createIconBySocialItem(social);
        const { href, noindex, nofollow, openInNew } = social;
        const rel = ['noopener', 'noreferrer', noindex ? 'noindex' : false, nofollow ? 'nofollow' : false];
        if (!IconSocial)
            return null;
        return (React.createElement(Link, { className: modules_b21bc4dc.socialsIcons, key: href, color: "gray", href: href, target: openInNew ? '_blank' : '_self', rel: rel.filter(Boolean).join(' '), "aria-label": social.text },
            React.createElement(Icon, { className: "h-color-D30", icon: IconSocial })));
    })));
};
const Socials = ({ className, socialLinks, ...rest }) => {
    const cx = useStyles(modules_b21bc4dc);
    return (React.createElement(Space, { size: 36, justify: "space-between", inline: true, className: cx(className, 'h-mt-8 h-mb-8'), ...rest },
        React.createElement(SocialList, { socialLinks: socialLinks })));
};
Socials.displayName = 'Socials';

export { Socials };
//# sourceMappingURL=Socials.js.map
